if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');
        if (variantInput) variantInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler);
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span')
          : null;
        this.submitButtonIcon = this.submitButton
          ? this.submitButton.querySelector('.js-add-to-cart-icon')
          : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        if (this.submitButtonText) this.submitButtonText.style.opacity = '0';
        if (this.submitButtonIcon) this.submitButtonIcon.style.opacity = '0';

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const buildItem =
          typeof window.buildCartAddItemFromFormData === 'function'
            ? window.buildCartAddItemFromFormData
            : (data) => ({
                id: data.get('id'),
                quantity: parseInt(data.get('quantity'), 10) || 1,
              });
        const item = buildItem(formData);

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items: [item] }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            if (typeof window.updateCartAfterAdd === 'function') {
              window.updateCartAfterAdd(response, {
                variantId,
                source: 'product-form',
              });
            } else {
              const cartDrawer = document.querySelector('cart-drawer');
              cartDrawer?.open?.();
              cartDrawer?.refreshCartDrawer?.();
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: variantId,
                  cartData: response,
                });
              } catch (error) {
                console.error('cartUpdate publish failed after add to cart:', error);
              }
            }

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer?.classList.contains('is-empty')) {
              cartDrawer.classList.remove('is-empty');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.submitButton) return;
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
            if (this.submitButtonText) this.submitButtonText.style.opacity = '';
            if (this.submitButtonIcon) this.submitButtonIcon.style.opacity = '';
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
